
// Import JS Modules
import TemplateStore from '../templates/template-store';
import { stickerStore, patternStore } from '../utils/stores';
import wkDataInterrogator from '../misc/wk-data-interrogator';
import { fetchFavourites } from '../utils/fetch-favourites';
import { TYPES } from "../common/tray-base";
import templateInterrogator from '../misc/template-interrogator';
import prismItemInterrogator from '../misc/prism-item-interrogator';
import { usePrismItemStore } from 'stores/usePrismItemStore';


function designCode() {
  const prismItem = usePrismItemStore.getState().prismItem
  return prismItem && prismItem.design_code || '';
}

function isCustomColor() {
  return designCode().indexOf('.customcolor') > 0;
}

function isCollage() {
  const code = designCode();
  return (code.indexOf('.collage') === (code.length - 8))
    || (code.indexOf('.collage.') !== -1)
    || (code.indexOf('collage.') === 0);
}

async function hasEventsTray() {
  return window.wkData && isCalendar() && (await usePrismItemStore.getState().setDayEventsSlots()).length > 0;
}

function isAlbum() {
  return wkDataInterrogator.isAlbum();
}

function isCalendar() {
  return wkDataInterrogator.isCalendar();
}

function isCanvas() {
  return (wkData.product
    && wkData.product.type === 'framedcanvas'
    || wkData.product.type === 'canvaswrap');
}

function isMultiPageCardProduct() {
  const productType = 'wmcard';

  return wkData.product['max-pages'] > 1 && wkData.product.type === productType;
}

function isMultiPageStandardProduct() {
  const nonMultiPageProductTypes = ['album', 'wmcard', 'calendar', 'businesscard'];
  return wkData.product['max-pages'] > 1 && nonMultiPageProductTypes.every((productType) => wkData.product.type !== productType);
}

function hasLayoutsTray() {
  const templateGroups = TemplateStore.list();
  if (!templateGroups) return false;

  const orientationFilter = templateInterrogator.orientationFilter(window.activeView.template);
  const availableFilteredTemplates = TemplateStore.templatesFiltered({
    section: prismItemInterrogator.getCurrentSection(),
    orientations: orientationFilter,
  });

  if (orientationFilter === "is-landscape" || orientationFilter === "is-portrait") return true;
  if (availableFilteredTemplates.length >= 2) return true;
  if (isCollage() || isCustomColor()) return true;
  if (activeView && typeof activeView.hasOptionalBackground === 'function' && activeView.hasOptionalBackground()) return true;

  return false;
}


function hasEdgesTray() {
  return wkData.product.type === 'canvaswrap'
    && wkData.vars.length === 0
    && TemplateStore.wraps();
}

async function hasColourTray() {
  if(!window.activeView) return false;

  if (window.activeView
    && typeof activeView.hasOptionalBackground === 'function'
    && activeView.hasOptionalBackground()) {
    return true;
  }

  try {
    if (await hasStickersTray()) {
      return true;
    }
  } catch (error) {
    console.error('Error checking stickers tray:', error);
  }
  
  try {
    if (await hasPatternsTray()) {
      return true;
    }
  } catch (error) {
    console.error('Error checking patterns tray:', error);
  }
  
}

function hasWrapsTray() {
  return TemplateStore.hasWraps;
}

function* chicletVariables() {
  for (const variable of wkData.vars) {
    if (variable.builder_chiclet_option && variable.options.length > 1) {
      yield variable;
    }
  }
}

function* chicletCardVariables() {
  for (const variable of wkData.vars) {
    if (variable.builder_chiclet_option) {
      yield variable;
    }
  }
}

function chicletVariablesPrimary() {
  // there are no top level (have their own chiclets) if wkData.product_tray_enabled
  if (wkData.product_tray_enabled) {
    return [];
  }

  return Array.from(chicletVariables())
    .filter(variableWouldBePrimary);
}

function chicletVariablesSecondary() {
  const variables = Array.from(chicletVariables());

  return variables;
}

function findVariable(name) {
  return [...chicletVariables()].find((v) => v.name === name);
}

function findCardVariable(name) {
  return [...chicletCardVariables()].find((v) => v.name === name);
}

function hasVariablesTray() {
  return [...chicletVariablesSecondary()].length > 0;
}

function variableWouldBePrimary({ name: variableName }) {
  return ['frame', 'cover'].some((chicletName) => variableName.match(new RegExp(chicletName, 'i')));
}

async function hasFavouritesTray() {
  const favourites = await fetchFavourites();
  return favourites?.length > 0;
}

async function hasStickersTray() {
  return await stickerStore.some();
}

async function hasPatternsTray() {
  return await patternStore.some();
}

function isPartOfDesignTray(activeTray) {
  const validTypes = [
    // TYPES.text,
    TYPES.photos,
    TYPES.favourites,
    TYPES.colours,
    TYPES.layouts
  ];

  return validTypes.includes(activeTray);
}

export {
  hasFavouritesTray,
  hasLayoutsTray,
  hasEdgesTray,
  hasColourTray,
  hasEventsTray,
  isAlbum,
  isCalendar,
  isCanvas,
  isMultiPageCardProduct,
  isMultiPageStandardProduct,
  chicletVariables,
  chicletCardVariables,
  chicletVariablesPrimary,
  chicletVariablesSecondary,
  findVariable,
  findCardVariable,
  hasVariablesTray,
  hasWrapsTray,
  hasStickersTray,
  hasPatternsTray,
  isPartOfDesignTray
};
